const isFn = x => typeof x === "function";

const plural = (words, count) => {
  words = words.split("|").map(x => x.trim());
  return count > 1 ? words[2].replace("{n}", count) : words[count];
};

// Given a Vuelidate validations object, find the validator keys
export function extractValidatorKeys(validations, validators = []) {
  const keys = Object.keys(validations);
  validators.push(...keys.filter(x => isFn(validations[x])));
  keys
    .filter(x => !isFn(validations[x]))
    .forEach(x => extractValidatorKeys(validations[x], validators));
  return validators;
}

export const getValMessage = messages => validations => {
  let keys = extractValidatorKeys(validations);
  // check to make sure all validators have corresponding error messages
  const missing = keys.filter(x => !(x in messages));
  if (missing.length) {
    console.warn(
      `Validators missing validation messages: ${missing.join(", ")}`
    );
    keys = keys.filter(x => missing.indexOf(x) < 0);
  }
  const keyLen = keys.length;

  // Vue component method
  // Given a vuelidate field object, maybe return an error messsage
  return function(field) {
    if (!field.$dirty) return null;
    let key;
    for (let i = 0; i < keyLen; i++) {
      key = keys[i];
      if (field[key] === false) return messages[key](field.$params[key]);
    }
    return null;
  };
};

export const valMessages = {
  required: () => "This field is required",
  shortRequired: () => "Required",
  notValid: () => "Not valid",
  email: () => "E-mail must be valid",
  phone: () => "Phone must contain 10 digits",
  numeric: () => "Must be a number",
  decimal: () => "Must be a number",
  integer: () => "Must be a whole number",
  positive: () => "Must be larger than 0",
  largerThenOne: () => "Must be larger than 1",
  notNegative: () => "Cannot be negative",
  odometer: () => "Must be 4 digits",
  zipCode: () => "Zip code must contain 5 digits",
  couponCode: () => "Coupon Code is not valid",
  onlyLettersAndNumbers: () => "Can contain only letters and numbers",
  urlFriendly: () => "Can contain only letters, numbers, dashes and underscores",
  noSlash: () => "Cannot contain forward slashes",
  password: () => "At least 8 characters",
  sameAsPassword: () => "The passwords must match.",
  sameAsEmail: () => "The new email must match.",
  diferentFromOldPassword: () => "New password must differ from current.",
  differentFromOldEmail: () => "New mail must differ from the old one.",
  endDate: () => "Must be after Start Date",
  toDate: () => "Cannot be before From Date",
  pausedToDate: () => "Must be after Paused From Date",
  agree: () => "You must agree to continue!",
  microdeposit: () => "Must be 2 digits",
  url: () => "Must be valid URL (https://www.example.com/)",
  txtMinLen: params => {
    const min = plural(
      "no characters | one character | {n} characters",
      params.min
    );
    return `Must be at least ${min}`;
  },
  txtMaxLen: params => {
    const max = plural(
      "no characters | one character | {n} characters",
      params.max
    );
    return `Must be less or equal ${max}`;
  },
  arrayMinLen: params => {
    const min = plural("no item | one item | {n} items", params.min);
    return `Must be at least ${min}`;
  },
  arrayMaxLen: params => {
    const max = plural("no items | one item | {n} items", params.max);
    return `Maximum ${max} can be selected`;
  },
  serviceDays: params => {
    return `${params.value} service days must be selected`;
  }
};
